module.exports = __webpack_public_path__ + "static/CONF_SECCION-475b5dee44c318550f5a33291ac1c9be.png";